<template>
    <div>
        <RouterView />
        <Notification />
    </div>
</template>

<script setup>
import {computed, onBeforeMount, onBeforeUnmount, onMounted} from 'vue'

import { RouterView } from 'vue-router'
import Notification from '@/components/Notification.vue'

import { useGlobalStore } from '@/stores/global'

/** Stores */
const settingsStore = useGlobalStore()

/** Hooks */
onBeforeMount(() => {
    // setLanguage()
    settingsStore.getSiteSettings(import.meta.env.VITE_SITE_UUID)
    .then(() => {
        // console.log('Site settings fetched')
    })
    .catch((error) => {
        // console.log(error.status)
    })
})
</script>
